import { useEffect, useState } from 'react';
import { getProxyObject, PropertiesChain, proxyWatch, UnWatch } from '../watcher/proxyWatch';
import { Log } from '../log';

let count = 0;
/**
 * 注意，如果target不是proxy对象，那么更改target的属性不会触发更新，这种情况可以使用返回的proxy对象。
 * @param target 监听的对象
 * @param propertyChain 监听的属性链
 * @param defaultValue 默认值
 * @returns [value, proxy, unsub] value: 监听的属性值, proxy: 监听的对象, unsub: 取消监听
 */
export function useProxyWatch<T extends object, U>(
  target: T,
  propertyChain: PropertiesChain<T>,
  defaultValue: U,
): [U, T, UnWatch] {
  const logger = new Log(false, 'useProxyWatch_fn');
  logger.pause = true;
  if(!propertyChain){
    console.error('propertyChain is undefined',defaultValue, target)
  }
  const [value, setValue] = useState(defaultValue);
  const [proxy] = useState(getProxyObject(target).proxy);

  let isFirstUpdate = true;
  const onUpdate = (now: U, old?: U) => {
    logger.log('onUpdate_fn=', 'propertyChain=', propertyChain, 'now=', now, 'old=', old);
    if(!now){
      if(isFirstUpdate){
        now = defaultValue;
      }
    }
    if(!now){
      // console.trace("ggggggggggggggggggg223", isFirstUpdate, defaultValue, propertyChain)
    }
    if(isFirstUpdate){
      isFirstUpdate = false;
    }
    setValue(now);
  };

  const onUndefined = (info: any) => {
    logger.log('onUndefined_fn=', 'propertyChain=', propertyChain, 'info=', info);
    if (value === defaultValue) return;
    if(!isFirstUpdate)return;
    isFirstUpdate = false;
    setValue(defaultValue);
  };

  let unwatch: UnWatch | null = null;
  function unsub() {
    unwatch?.();
    unwatch = null;
  }

  useEffect(() => {
    if(propertyChain){
        unwatch = proxyWatch(target, propertyChain, onUpdate, onUndefined).unwatch;
    }
    return () => {
      unwatch?.();
    };
  }, []);
  return [value, proxy, unsub];
}
